import React, { useEffect, useState, useRef } from 'react';

import { Box } from '@mui/material';
import { useAuthContext } from 'AuthProvider';
import { MasterSearchFrom, FileDownloadData, SearchBox } from 'components/commonparts'
import { DataList } from 'components/parts/MasterCustomer';
import { useCustomer } from 'hooks/useCustomer';
import { useGridSearch } from 'hooks/useGridSearch';

import type { GetMstCentersCenterGetRequest, MstCustomer, ResponseResult } from 'api-client';

function MasterCustomer() {
  const { loginUserInfo } = useAuthContext()
  const trCompanyId = loginUserInfo?.companyId;

  // 自社のcompanyIdのみ検索条件をローカルストレージから復元
  const initSearchParam: GetMstCentersCenterGetRequest = {
    companyId: trCompanyId ?? loginUserInfo!.companyId,
  }

  const [hasGridEdited, setHasGridEdited] = useState<boolean>(false)
  const [downloadGridRows, setDownloadGridRows] = useState<MstCustomer[]>([])
  const [downloadMode, setDownloadMode] = useState<string>('csv')
  const [downloadColDef, setDownloadColDef] = useState<any[] | undefined>([]);

  const [resultMessage, setResultMessage] = useState<ResponseResult | undefined>(undefined)
  const [gridMessage, setGridMessage] = useState<ResponseResult | undefined>(undefined)

  const { result, isLoading, customers, fetchCustomer, customerSearchResult } = useCustomer()
  const gridSearch = useGridSearch({ autoShowOnCtrlF: true })
  const isFirstRender = useRef(true);
  const [uploadData, setUploadData] = useState<any[]>([])
  const [updateTrigger, setUpdateTrigger] = useState<boolean | undefined>(undefined);
  const [discardChangeDialogOpen, setDiscardChangeDialogOpen] = useState<boolean>(false)
  
  useEffect(() => {
    setResultMessage(customerSearchResult)
  }, [customerSearchResult])
  useEffect(() => {
    setResultMessage(result)
  }, [result])
  useEffect(() => {
    setResultMessage(gridMessage)
  }, [gridMessage])

  // const doSearch = useCallback(async (requestParam: GetMstCentersCenterGetRequest) => {
  //   if (hasGridEdited) {
  //     setDiscardChangeDialogOpen(true)
  //     return
  //   }
  //   try {
  //     fetchCenterSearch({
  //         ...requestParam,
  //       });
  //       // fetchSupplier({
  //       //   companyId: requestParam.companyId, 
  //       // });
  //       if (requestParam.companyId === loginUserInfo!.companyId && loginUserInfo?.tenantId && loginUserInfo?.companyId) {
  //         setSearchParamState<GetMstCentersCenterGetRequest>(
  //           loginUserInfo?.tenantId,
  //           loginUserInfo?.companyId,
  //           'Center',
  //           {
  //             ...requestParam,
  //           }
  //         );
  //       }
  
  //       setSearchParam(requestParam);
  //       setHasGridEdited(false)
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     } 
  // }, [centerSearch]);

  const handleRegister = () => {
    setUpdateTrigger((prev) => !prev);
  }

  const handleUploadData = async (headers: any[], data: any[]) => {
    // エクセルファイルからデータをインポートし、ヘッダーとデータ行に分けて渡される
    const mappedData = data.map((row) => {
      const obj: any = {};
      headers.forEach((header, index) => {
        obj[header] = row[index];
      });
      return obj;
    });
    setUploadData(mappedData); 
  };

  const onReload = () => {
    fetchCustomer({
      enabled: false,
      ...initSearchParam,
    }, true) // Force refresh = true
    setHasGridEdited(false)
  }

  useEffect(() => {
    const firstTimeRender = async () => { 
      if (isFirstRender.current) {
        isFirstRender.current=false
        const itemsPromise = fetchCustomer({
          enabled: false,
          ...initSearchParam,
        }, true);
        await Promise.all([itemsPromise]);
      }
    }
    firstTimeRender()
  }, [])

  const generateDownloadData = (): MstCustomer[] => {
    if (!customers?.list || customers.list.length === 0) {
      return [{} as MstCustomer]
    }
    const downloadData: MstCustomer[] = [...customers.list]
    return downloadData
  }
  
  const handleFileDownload = () => {
    setDownloadGridRows(generateDownloadData())
  }

  return (
    <Box>
      <MasterSearchFrom
          result={resultMessage}
          onDoUpdate={handleRegister}
          onReload={onReload}
          onImportData={handleUploadData}
          onFileDownLoad={handleFileDownload}
          discardChangeDialogOpen={discardChangeDialogOpen}
          setDownloadMode={setDownloadMode}
          hasDataEdited={hasGridEdited}
          importRequiredFields={["org_customer_id"]}
          headerJp={["得意先企業ID"]}
          lastUpdateDatetime={customers?.lastUpdateDatetime}
        />
      <FileDownloadData fileName="得意先" downloadData={downloadGridRows} downloadMode={downloadMode} columnDefs={downloadColDef} />
      <SearchBox
        gridRef={gridSearch.searchBoxProps.gridRef}
        findSearchValue={gridSearch.searchBoxProps.findSearchValue}
        setFindSearchValue={gridSearch.searchBoxProps.setFindSearchValue}
        activeMatchNum={gridSearch.searchBoxProps.activeMatchNum}
        onFindChanged={gridSearch.searchBoxProps.onFindChanged}
        isVisible={gridSearch.searchBoxProps.isVisible}
        onHide={gridSearch.searchBoxProps.onHide}
      />
      <DataList
          list={customers}
          onReload={onReload}
          isLoading={isLoading}
          searchParam={initSearchParam}
          onUploadData={uploadData}
          updateTrigger={updateTrigger}
          setHasGridEdited={setHasGridEdited}
          setResultMessage={setGridMessage}
          setDownloadColumnDefs={setDownloadColDef}
          gridRef={gridSearch.gridRef}
          findSearchValue={gridSearch.gridSearchProps.findSearchValue}
          onFindChanged={gridSearch.gridSearchProps.onFindChanged}
          isSearchVisible={gridSearch.searchBoxProps.isVisible}
        />
    </Box>
  )
}

export default MasterCustomer;
